<div class="section section-whatwedo bg-white d-flex flex-column justify-content-center">

  <a class="section-anchor" name="section-whatwedo"></a>

  <div class="container-section text-columns container d-flex flex-column justify-content-center">

    <div class="row">

      <div class="col-12 d-flex flex-column text-center">

        <h3 class="alternate-heading text-center text-primary mb-3">{{'What does Meet the Youngsters do?' | translate}}</h3>

        <h3 class="text-center flex-grow-1">
          <span>{{'Employer Branding' | translate}}</span>
        </h3>

        <p class="flex-grow-1 alternate-heading-subline">
          {{ 'Meet the Youngsters helps companies increase their brand awareness among young people. This is done, among other things, by: the online matching platform and the Employer Branding services of Meet the Youngsters. Curious about how these services can help you increase your brand awareness among young people?' | translate }}
        </p>

        <div class="row">

          <div class="col-12 text-center">
            <a class="btn btn-primary btn-special btn-sm" routerLink="/pages/diensten">
              {{ 'Click here' | translate }}
            </a>
          </div>

        </div>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-12 d-flex flex-column text-center">

        <h3 class="text-center flex-grow-1">
          <span>{{'Informing youngsters' | translate}}</span>
        </h3>

        <p class="flex-grow-1 alternate-heading-subline">
          {{ 'Unknown makes unloved. Many young people have no idea what great companies there are in the region, but Meet the Youngsters is changing that. Through the online matching platform, young people are linked to companies that suit them best. On this basis, young people can orientate themselves on the possibilities in their region and beyond! Curious about the platform?' | translate }}
        </p>

        <div class="row">
          <div class="col-12">
            <a class="btn btn-primary btn-special btn-sm" routerLink="/our-network">
              {{ 'Click here' | translate }}
            </a>
          </div>
        </div>

      </div>
    </div>

    <div class="row mt-5">
      <div class="col-12 d-flex flex-column text-center">

        <h3 class="text-center flex-grow-1">
          <span>{{'Collaboration with educational institutions' | translate}}</span>
        </h3>

        <p class="flex-grow-1 alternate-heading-subline">
          {{ 'Meet the Youngsters works closely with educational institutions to help young people make the right choices. To achieve this, Meet the Youngsters gives various guest lessons. By means of serious gaming responds to the experiences of young people. Curious about these guest lessons?' | translate }}
        </p>

        <div class="row mb-5">
          <div class="col-12">
            <a class="btn btn-primary btn-special btn-sm" routerLink="/pages/onderwijs">
              {{ 'Click here' | translate }}
            </a>
          </div>
        </div>


        <div *ngIf="['NL', 'BE'].includes(domain.getCurrentRegion())">
          <h3 class="text-center flex-grow-1">
            <span>{{'Collaborate with associations / municipalities / provinces' | translate}}</span>
          </h3>

          <p class="flex-grow-1 alternate-heading-subline">
            {{ 'To achieve the objectives, Meet the Youngsters works together with the province of Limburg, various municipalities, employer associations and business communities. We work together with:' | translate }}
          </p>

          <!-- nl partner logos -->
          <div *ngIf="domain.getCurrentRegion() == 'NL'" class="section section-partners section-partners-nl height-auto">

            <div class="container-fluid">

              <div class="container-section">

                <!-- desktop slider -->
                <div class="d-none d-sm-block slider-partners slider-partners-be">
                  <ngb-carousel [showNavigationArrows]="false" [showNavigationIndicators]="false" *ngIf="partnerSliderNL.slides_desktop">
                    <ng-template *ngFor="let slide of partnerSliderNL.slides_desktop" ngbSlide>

                      <div class="row">

                        <div class="col-4" *ngFor="let slideItem of slide">
                          <div class="item-wrapper text-center">
                            <div class="img-wrapper">
                              <a class="link" [href]="slideItem.url" target="_blank">
                                <img class="img-fluid image filter-grayscale filter-grayscale-hover-color" [src]="slideItem['image_url']" [attr.alt]="slideItem['title']">
                              </a>
                            </div>
                          </div>
                        </div>

                      </div>

                    </ng-template>
                  </ngb-carousel>
                </div>

                <!-- mobile slider -->
                <div class="d-block d-sm-none slider-partners slider-partners-be">
                  <ngb-carousel [showNavigationArrows]="true" [showNavigationIndicators]="false" *ngIf="partnerSliderNL.slides_mobile">
                    <ng-template *ngFor="let slide of partnerSliderNL.slides_mobile" ngbSlide>

                      <div class="row">

                        <div class="col-6" *ngFor="let slideItem of slide">
                          <div class="item-wrapper">
                            <div class="img-wrapper">
                              <a class="link" [href]="slideItem.url" target="_blank">
                                <img class="img-fluid image filter-grayscale filter-grayscale-hover-color" [src]="slideItem['image_url']" [attr.alt]="slideItem['title']">
                              </a>
                            </div>
                          </div>
                        </div>

                      </div>

                    </ng-template>
                  </ngb-carousel>

                </div>

              </div>

            </div>
          </div>

          <!-- be partner logos -->
          <div *ngIf="domain.getCurrentRegion() == 'BE'" class="section section-partners section-partners-be height-auto">

            <div class="container-fluid">

              <div class="container-section">

                <!-- desktop slider -->
                <div class="d-none d-sm-block slider-partners slider-partners-be">
                  <ngb-carousel [showNavigationArrows]="false" [showNavigationIndicators]="false" *ngIf="partnerSliderBE.slides_desktop">
                    <ng-template *ngFor="let slide of partnerSliderBE.slides_desktop" ngbSlide>

                      <div class="row">

                        <div class="col-4" *ngFor="let slideItem of slide">
                          <div class="item-wrapper text-center">
                            <div class="img-wrapper">
                              <a class="link" [href]="slideItem.url" target="_blank">
                                <img class="img-fluid image filter-grayscale filter-grayscale-hover-color" [src]="slideItem['image_url']" [attr.alt]="slideItem['title']">
                              </a>
                            </div>
                          </div>
                        </div>

                      </div>

                    </ng-template>
                  </ngb-carousel>
                </div>

                <!-- mobile slider -->
                <div class="d-block d-sm-none slider-partners slider-partners-be">
                  <ngb-carousel [showNavigationArrows]="true" [showNavigationIndicators]="false" *ngIf="partnerSliderBE.slides_mobile">
                    <ng-template *ngFor="let slide of partnerSliderBE.slides_mobile" ngbSlide>

                      <div class="row">

                        <div class="col-6" *ngFor="let slideItem of slide">
                          <div class="item-wrapper">
                            <div class="img-wrapper">
                              <a class="link" [href]="slideItem.url" target="_blank">
                                <img class="img-fluid image filter-grayscale filter-grayscale-hover-color" [src]="slideItem['image_url']" [attr.alt]="slideItem['title']">
                              </a>
                            </div>
                          </div>
                        </div>

                      </div>

                    </ng-template>
                  </ngb-carousel>

                </div>

              </div>

            </div>
          </div>
        </div>

      </div>
    </div>

  </div>

</div>
